module.exports = __webpack_public_path__ + "img/glow-posterized-large.4994224e.png";